import { getObject } from 'larasnap/helpers';
import data from './data';

export const getAppData = key => getObject(data, key);

export const getAppConfig = key => getObject(data.config, key);

export const environment = keys => {
    if (!Array.isArray(keys)) keys = [keys];
    return keys.includes(data.config.env);
};

export const user = getAppData('user');
